import {t} from '@lingui/macro'
import type {FC} from 'react'
import styled from 'styled-components'

import {tokens} from '@pleo-io/telescope'

import {theme} from 'styles/theme'
import {useUser, getEmployeeStatus} from '~/shell/user'

interface Props {
    feature: string
    dot?: boolean
    pill?: boolean
    color?: string
    seen?: boolean
    className?: string
    label?: string
}

export const NewFeature: FC<Props> = ({feature, dot, pill, color, label, seen, className}) => {
    const user = useUser()
    const employeeStatusSeen = !!getEmployeeStatus(user)[`@pleo/new-feature/${feature}`]
    const hide = seen ?? employeeStatusSeen

    if (!hide && (dot || (!dot && !pill))) {
        return (
            <Dot
                data-testid="new-feature-dot"
                data-generic-ui="new-feature"
                className={className}
            />
        )
    }
    if (!hide && pill) {
        return (
            <Pill
                color={color || theme.colors.pink300}
                data-testid="new-feature-pill"
                className={className}
                data-generic-ui="new-feature"
            >
                {label || t`New`}
            </Pill>
        )
    }

    return null
}

export default NewFeature

const Pill = styled.span<{color?: string}>`
    display: inline-flex;
    align-items: center;
    font-size: 12px;
    line-height: ${tokens.lineHeight2};
    text-transform: uppercase;
    border-radius: ${tokens.arc4};
    color: ${tokens.shade700};
    margin-left: ${tokens.spacing4};
    padding: ${tokens.spacing2} ${tokens.spacing6};
    background-color: ${(props) => props.color ?? tokens.shade200};
`

export const Dot = styled.div`
    width: ${tokens.spacing4};
    height: ${tokens.spacing4};
    background-color: ${tokens.pink600};
    border-radius: ${tokens.circle};
`
